import React from "react";
import { NavLink } from "react-router-dom";
import {
  RiHome5Line,
  RiWallet3Line,
  RiGiftLine,
  RiCustomerService2Line,
  RiUser3Line,
} from "react-icons/ri";

const BottonMenu = ({ w3_close }) => {
  return (
    <div className="main_bottom_menus">
      <nav className="bottom_link_main">
        <NavLink
          to="/landing"
          className="bottom_link"
          activeClassName="active_link"
          isActive={(match, location) =>
            location.pathname === "/" ||
            location.pathname.startsWith("/landing") ||
            location.pathname.startsWith("/Homepage") ||
            location.pathname.startsWith("/homepage")
          }
          onClick={w3_close}
        >
          <div className="bottom_icon_wrapper">
            <RiHome5Line className="bottom_nav_icon" />
          </div>
          <span>Home</span>
        </NavLink>

        <NavLink
          to="/wallet"
          className="bottom_link"
          activeClassName="active_link"
          isActive={(match, location) =>
            location.pathname.toLowerCase().startsWith("/wallet") ||
            location.pathname.toLowerCase().startsWith("/addcase") ||
            location.pathname.toLowerCase().startsWith("/withdraw")
          }
          onClick={w3_close}
        >
          <div className="bottom_icon_wrapper">
            <RiWallet3Line className="bottom_nav_icon" />
          </div>
          <span>Wallet</span>
        </NavLink>

        <NavLink
          to="/refer"
          className="bottom_link"
          activeClassName="active_link"
          isActive={(match, location) =>
            location.pathname.toLowerCase().startsWith("/refer")
          }
          onClick={w3_close}
        >
          <div className="bottom_icon_wrapper">
            <RiGiftLine className="bottom_nav_icon" />
          </div>
          <span>Refer</span>
        </NavLink>

        <NavLink
          to="/support"
          className="bottom_link"
          activeClassName="active_link"
          isActive={(match, location) =>
            location.pathname.toLowerCase().startsWith("/support") ||
            location.pathname.toLowerCase().startsWith("/contact-us")
          }
          onClick={w3_close}
        >
          <div className="bottom_icon_wrapper">
            <RiCustomerService2Line className="bottom_nav_icon" />
          </div>
          <span>Support</span>
        </NavLink>

        <NavLink
          to="/profile"
          className="bottom_link"
          activeClassName="active_link"
          isActive={(match, location) =>
            location.pathname.toLowerCase().startsWith("/profile") ||
            location.pathname.toLowerCase().startsWith("/kyc")
          }
          onClick={w3_close}
        >
          <div className="bottom_icon_wrapper">
            <RiUser3Line className="bottom_nav_icon" />
          </div>
          <span>Profile</span>
        </NavLink>
      </nav>
    </div>
  );
};

export default BottonMenu;
